import { thousandSeparated } from 'shared/util/formatting';
import type { PaleVertical } from '@/interfaces';

type ResultCountProps = {
    numberOfOffers?: number;
    vertical: PaleVertical;
};

export const ResultCount = ({ numberOfOffers, vertical }: ResultCountProps) => (
    <output className="whitespace-nowrap" data-testid="resultCount">
        <span className="font-bold">{numberOfOffers ? thousandSeparated(numberOfOffers) : '0'}</span>{' '}
        {vertical === 'lms' || vertical === 'pp' ? 'treff' : 'ulike hoteller'}
    </output>
);
